<script>
    import R, {LOADER} from "../lib/requests";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";
    import {setFocusTo} from "../lib/lib";
    import Notifier from "../stores/notifier";

    export let driverId = null;
    export let transporterId = 0;
    export let closeCallback;

    let driver = null;

    const initialize = () => {
        if (driverId == 0) {
            driver = {
                id: 0,
                transporter_id: transporterId,
                name: '',
                mobile: '',
                email: '',
                is_local: 0,
                is_active: 1,
            }
            setFocusTo('driverName');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            driver = result;
            setFocusTo('driverName');
        };

        const onFailure = err => {
        };

        R.handle(R.driver.details, driverId, onSuccess, onFailure, LOADER.POPUP);
    };

    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Driver saved");
            close(result);
        }

        const onFailure = err => {
        };

        driver.name = driver.name.trim();
        if (!driver.name) {
            Notifier.showError("Enter the name of the driver!");
            setFocusTo("driverName");
            return;
        }

        let action = driverId == 0 ? 'create' : 'edit';
        R.handle(R.driver[action], driver, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        driver = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    initialize();

</script>


{#if driver}
    <Modal title="Driver" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" id="driverName" bind:value="{ driver.name }"
                       required>
            </div>
            <div class="form-group">
                <label>Mobile</label>
                <input type="tel" class="form-control" bind:value="{ driver.mobile }">
            </div>
            <div class="form-group">
                <label>Email</label>
                <input type="email" class="form-control" bind:value="{ driver.email }">
            </div>
            <div class="form-group">
                <Checkbox label="Can make local transfers" bind:checked={ driver.is_local }/>
            </div>
            <div class="form-group">
                <Checkbox label="Active driver" bind:checked={ driver.is_active }/>
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-2" on:click="{ () => close() }">Close</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Save</button>
            </div>
        </div>
    </Modal>
{/if}